import { useQuery } from '@tanstack/react-query';

import { JoinStrategy } from '@/features/experiment/detail/metrics/metric-row';
import { queryKeys } from '@/hooks/constants';
import Service from '@/lib/App';

export function useGetAnalysis(
  experimentName: string,
  options?: { [key: string]: any },
) {
  return useQuery({
    queryKey: queryKeys.planner.analysis(experimentName),
    queryFn: () => Service.planner.fetchAnalysisConfig(experimentName),
    ...options,
  });
}

export function useFetchMetricDimensions(
  metricName: string,
  strategy: string,
  joinStrategy?: JoinStrategy,
  assignByFacet?: string,
  options?: { [key: string]: any },
) {
  return useQuery({
    queryKey: queryKeys.planner.metricDimensions(metricName),
    queryFn: () =>
      Service.planner.fetchDimensions(metricName, {
        purpose: 'deepdives',
        strategy,
        joinStrategy,
        assignByFacet,
      }),
    ...options,
  });
}
